export const REMEMBER_AUTOFILL_TOOLTIP_SHOWN = "autofillTooltipShown";
